import { render, staticRenderFns } from "./CreateAccountScreen.vue?vue&type=template&id=9f06936e&"
import script from "./CreateAccountScreen.vue?vue&type=script&lang=ts&"
export * from "./CreateAccountScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput,QIcon,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QIcon,QBtn})
